// @core/api/endpoints/secret/create_database_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateDatabaseRoleRequest,
  DatabaseRoleResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Create database role
 * Creates a database role that defines how dynamic credentials are generated — connection URL, SQL statements for user creation/revocation, and TTL limits.
 */
export async function CreateDatabaseRole(
  engine_id: string,
  data: CreateDatabaseRoleRequest,
  options?: RequestOptions
): Promise<DatabaseRoleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/database/roles`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.post<DatabaseRoleResponse>(requestPath, data, requestOptions);
}
